/* Component to fetch the Schedule Scene Characters and Background data
 * Contains the SchedCharacter component
 * Contains the SchedBackground component */
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import styles from "../../../styles/ScheduleSceneItem.module.css"

const ScheduleCharacters2 = ({title, act}) => {

  return (
    <div className={`text-center py-2 mb-2 mx-2 mx-md-5 px-2 ${styles.SceneBox}`} >
    {act ? (
    <div className="mb-4 mt-2" >
      <p className={`${styles.CharactersTitle } mb-1`} >CAST</p>
    <Row >
    <Col xs={12}>
    <div className={`${styles.BgBox} text-center px-3 mx-0`}>
      <p>{act} </p>
    </div>
    </Col>
    </Row>
    </div>
    ) : ("") }
    <p className={`${styles.CharactersTitle } mt-2 mb-1`} >BACKGROUND - DOUBLES - STUNT ARTISTS</p>
    <Row >
    <Col xs={12}>
    <div className={`${styles.BgBox} text-center px-3 mx-0`}>
      <p>{title} </p>
    </div>
    </Col>
    </Row>
    </div>
  )
}

export default ScheduleCharacters2
